import types from '@/vuex/auth/mutations-types.js'

const mutations = {
  [types.ALTERAR_CONFIGURACOES_USUARIO]: (state, payload) => {
    state.usuario.configuracoes = payload
  },
  [types.SET_USUARIO]: (state, payload) => {
    state.usuario = payload.usuario
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/auth/mutations.js